import ClientClass4 from './client4.js';

const Client = new ClientClass4();   

export {
    Client,
};

